import VueRouter from "vue-router";
import Login from "../pages/mainpage/Login.vue";
import Main from "../pages/mainpage/Main.vue";
import Home from "../pages/mainpage/Home.vue";
import Detail from "../pages/mainpage/Detail.vue";
import DetailDetach from "../pages/mainpage/DetailDetach.vue";
import PersonnelAttendance from "../pages/mainpage/page/personnelAttendance/index.vue";
import CarAttendance from "../pages/mainpage/page/carAttendance/index.vue";
import Location from "../pages/mainpage/page/location/index.vue";
import Gas from "../pages/mainpage/page/gas/index.vue";
import SafeStep from "../pages/mainpage/page/safeStep/index.vue";
import Warning from "../pages/mainpage/page/warning/index.vue";
import VideoMonitoring from "../pages/mainpage/page/videoMonitoring/index.vue";
import RiskInvestigation from "../pages/mainpage/page/riskInvestigation/index.vue";
import ProcessTooling from "../pages/mainpage/page/processTooling/index.vue";
import SchemeDisclosure from "../pages/mainpage/page/schemeDisclosure/index.vue";
import ProgressManagement from "../pages/mainpage/page/progressManagement/index.vue";
import PartyBuilding from "../pages/mainpage/page/partyBuilding/index.vue";

import DrillData from "../pages/mainpage/page/drillData/index.vue";
import BoltGrouting from "../pages/mainpage/page/boltGrouting/index.vue";
import Ventilator from "../pages/mainpage/page/ventilator/index.vue";
import LiningTrolley from "../pages/mainpage/page/liningTrolley/index.vue";
import SmartProcess from "../pages/mainpage/page/smartProcess/index.vue";
import WebSocket from "../pages/mainpage/page/webSocket/index.vue";

import Register from "../pages/mainpage/Register.vue";
import LedUpdata from "../pages/mainpage/LedUpdata.vue";
import TunnelsRegister from "../pages/mainpage/TunnelsRegister.vue";

const routes = [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/main",
    component: Main,
    children: [
      // 这些子路由渲染到 Main.vue 的 <router-view>
      {
        path: "/home", // 导航数据
        name: "home",
        component: Home,
      },
      {
        path: "/detail", // 首页
        name: "Detail",
        component: Detail,
      },
      {
        path: "/detailDetach", // 详情页
        name: "DetailDetach",
        component: DetailDetach,
      },
      {
        path: "/personnelAttendance", // 人员考勤
        name: "PersonnelAttendance",
        component: PersonnelAttendance,
      },
      {
        path: "/carAttendance", // 车考勤
        name: "carAttendance",
        component: CarAttendance,
      },
      {
        path: "/location", // 人员位置
        name: "location",
        component: Location,
      },
      {
        path: "/gas", // 气体检测
        name: "gas",
        component: Gas,
      },
      {
        path: "/safeStep", // 安全步距
        name: "safeStep",
        component: SafeStep,
      },
      {
        path: "/warning", // 报警查询
        name: "warning",
        component: Warning,
      },
      {
        path: "/videoMonitoring", // 视频监控
        name: "videoMonitoring",
        component: VideoMonitoring,
      },
      {
        path: "/riskInvestigation", // 风险调查
        name: "riskInvestigation",
        component: RiskInvestigation,
      },
      {
        path: "/processTooling", // 工艺工装
        name: "processTooling",
        component: ProcessTooling,
      },
      {
        path: "/schemeDisclosure", // 方案交底
        name: "schemeDisclosure",
        component: SchemeDisclosure,
      },
      {
        path: "/progressManagement", // 进度管理
        name: "progressManagement",
        component: ProgressManagement,
      },
      {
        path: "/partyBuilding", // 党建建设
        name: "partyBuilding",
        component: PartyBuilding,
      },
      {
        path: "/drillData", // 三臂凿岩台车
        name: "drillData",
        component: DrillData,
      },
      {
        path: "/boltGrouting", // 锚注一体机
        name: "boltGrouting",
        component: BoltGrouting,
      },
      {
        path: "/ventilator", // 智能通风机
        name: "ventilator",
        component: Ventilator,
      },
      {
        path: "/liningTrolley", //  智能衬砌台车
        name: "liningTrolley",
        component: LiningTrolley,
      },
      {
        path: "/smartProcess", //  智能工序车
        name: "smartProcess",
        component: SmartProcess,
      },
    ],
  },
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/Register",
    component: Register,
  },
  {
    path: "/LedUpdata",
    component: LedUpdata,
  },
  {
    path: "/tunnelsRegister",
    component: TunnelsRegister,
  },
  {
    path: "/webSocket", //  WebSocket
    name: "webSocket",
    component: WebSocket,
  },
];

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
  mode: "history",
  routes, // (缩写) 相当于 routes: routes
});

router.beforeEach((to, from, next) => {
  // 如果目标路由和当前路由一样，则不进行跳转
  if (to.path === from.path) {
    // console.log('目标路由和当前路由相同，不做跳转');
    next(false); // 中断当前的导航
  } else {
    // console.log('目标路由和当前路由不同，继续跳转');
    next(); // 继续执行路由跳转
  }
});

// 在router.js中，
// 如果项目中跳转方式是push，就用：
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
// 如果跳转方式是replace，就用：
const original = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return original.call(this, location).catch((err) => err);
};
// 如果两种方式都有，上面两种都加上就可以了，本身对项目没什么影响。

export default router;
